export const REDIRECT_URL_UPDATE_SUCCESS = 'REDIRECT_URL_UPDATE_SUCCESS';

export interface preventLogoutState {
  token: string | null;
  // arn_link: string | null;
}
